import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { contentHeaders, apiBaseUrl } from "../common/config/config";
import { ActionSheetController, Platform, LoadingController, ToastController } from "@ionic/angular";
let apiUrl = apiBaseUrl + "insurance_companies/";
@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  public possibleStates = {
    MapPage: "/map",
    HomePage: "/home",
    ProfilePage: "/profile",
    FaqsPage: "/faqs",
    TermsPage: "/terms",
    RatingPage: "/rating",
    PayStaticPage: "/payment",
    SgssPage: "/sgss",
    ObdPage: "/obd",
    FinalPage: "/final",
    FormPage: "/form",
    PrivacyPage: "/privacy",
    SearchPage: "/search",
    AboutPage: "/about",
    CompanyPage: "/company",
    VideoPage: "/video",
    WorkshopsListPage: "/workshop",
    VocalStatementPage: "/audio",
    UndertakingSignaturePage: "/sign",
    CameraStencilsPage: "/camera",
  };
  public config: any;
  public insuranceCompany: any;
  public appType: any;

  public appStates = {
    auth: "HomePage",
    home: "MapPage",
    map: "CameraStencilsPage",
    csp: "VideoPage",
    vp: "FormPage",
    fp: "UndertakingSignaturePage",
    uts: "FinalPage",
    final: "HomePage",
  };
  public stencils = {
    uploadedStensile: [
      {
        type: "left",
        loc: "https://lccbucket.s3.ap-south-1.amazonaws.com/3Lcn4jTfVt.png",
      },
      {
        loc: "https://lccbucket.s3.ap-south-1.amazonaws.com/TYabqRfWWv.png",
        type: "front",
      },
      {
        type: "right",
        loc: "https://lccbucket.s3.ap-south-1.amazonaws.com/4YZ2U7omos.png",
      },
      {
        type: "back",
        loc: "https://lccbucket.s3.ap-south-1.amazonaws.com/OfYKCteiTs.png",
      },
    ],
  };
  public languages = [];
  public mobilePlateform = "";
  constructor(public http: HttpClient, private platform: Platform) {
    this.platform.ready().then(() => {
      if (!this.platform.is("cordova")) {
        return false;
      }
      if (this.platform.is("ios")) {
        this.mobilePlateform = "ios";
      } 
      else if (this.platform.is("android")) {
        this.mobilePlateform = "android";
        console.log("this.mobilePlateform in app-confid::::::::::::::::::::::::::", this.mobilePlateform);
      }
    });
  }
}
